import React, { useContext } from "react";
import { NavLink } from "react-router-dom";
import { AuthContext } from "../../context/authContext";
import MapRoundedIcon from '@mui/icons-material/MapRounded';
import EventRoundedIcon from '@mui/icons-material/EventRounded';
import ChecklistRoundedIcon from '@mui/icons-material/ChecklistRounded';
import PeopleOutlineRoundedIcon from '@mui/icons-material/PeopleOutlineRounded';
import BackupTableRoundedIcon from '@mui/icons-material/BackupTableRounded';
import "./navbarMobile.scss"


const NavBarMobile = () => {

    const { hasPermission, isLoading } = useContext(AuthContext);

    return isLoading ? (<div />) : (
        <div className="navMobile">
            {hasPermission("map", "read") &&
                <NavLink to="/map">
                    <MapRoundedIcon />
                    <span>Karte</span>
                </NavLink>
            }
            {hasPermission("planner", "read") &&
                <NavLink to="/calendar">
                    <EventRoundedIcon />
                    <span>Kalender</span>
                </NavLink>
            }
            {hasPermission("planner", "read") &&
                <NavLink to="/list">
                    <ChecklistRoundedIcon />
                    <span>Auftragsliste</span>
                </NavLink>
            }
            {hasPermission("data", "read") &&
                <NavLink to="/data">
                    <BackupTableRoundedIcon />
                    <span>Stammdaten</span>
                </NavLink>
            }
            {hasPermission("company", "read") &&
                <NavLink to="/customer">
                    <PeopleOutlineRoundedIcon />
                    <span>Kundenstammdaten</span>
                </NavLink>
            }
            {hasPermission("operator", "read") &&
                <NavLink to="/operator">
                    <ChecklistRoundedIcon />
                    <span>Fahrten</span>
                </NavLink>
            }
        </div>
    )
};

export default NavBarMobile